/** @jsxImportSource @emotion/react */
import { Button, Grid, Paper, Snackbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import { useEffect } from 'react';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { steps } from '../../Helper/AppStepperData';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import PersonalDetailsReview from './PersonalDetailsReview';
import PanDetailsReview from './PanDetailsReview';
import AddressDetailsReview from './AddressDetailsReview';
import FATCADetailsReview from './FATCADetailsReview';
import BankDetailsReview from './BankDetailsReview';
import BrokerageDetailsReview from './BrokerageDetailsReview';
import NomineeDetailsReview from './NomineeDetailsReview';
import PaymentDetailsReview from './PaymentDetailsReview';
import UploadedDocuments from './UploadedDocuments';
import UploadedDocumentViewer from '../../Components/UploadedDocumentViewer';
import { downloadPDF } from '../../Helper/Functions';

function Review(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [reviewData, setReviewData] = useState()
    const [loading, setLoading] = useState(false);
    const [uploadedDocProofID, setUploadedDocProofID] = useState()
    const localeText = useContext(Il8nContext)
    const location=useLocation()

    useEffect(() => {
        getReviewData()
		!(stepper?.length) && dispatch(updateStepper({ setDirectly : true, stepper : [1, 3, 3, 1] }))
    }, [])

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getReviewData = ()=>{
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL+config.fetchReviewDetails)
        .then(resp=>{
            setLoading(false)
            if(resp.data.success){
                setReviewData(resp.data.success[0])
                localStorage.setItem("reviewData", JSON.stringify(resp.data.success[0]))
            }
            else{
                throw new Error(resp.data.error)
            }
        })
        .catch(err=>{
            console.log(err.message)
            setLoading(false)
        })
    }

    const nextNavigation = ()=>{
        dispatch(updateStepper({ step: 4, nestedStep: 2 }));
        navigate("/Submit", {state: location?.state?.isFinalSubmitUser && {"isFinalSubmitUser":true}})
    }

    const handleFinalSubmit = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.finalSubmit)
            .then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    localStorage.setItem("kycid", String(resp.data.KYCID))
                    nextNavigation()
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(error=>{
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
                setLoading(false)
            })
    }

    const handleDownloadForm = ()=>{
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL+config.previewForm)
        .then(resp=>{
            setLoading(false)
            if(resp.data.success){
                downloadPDF(JSON.parse(resp.data.success).data.success)
            }
            else{
                throw new Error(resp.data.error)
            }
        })
        .catch(error=>{
            setResponseStatus({ "message": error.message, "type": "error" })
            setSnackBarOpen(true)
            setLoading(false)
        })
    }

    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} showSidebar 
                breadcrumb={{ show: true, steps: steps[3].nestedSteps, step: 4, nestedStep: 2 }}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} spacing={2} css={{alignItems: "flex-start"}}>
                        <Grid item xs={12}>
                            <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                {localeText?.reviewFinalReview}
                            </Typography>                            
                        </Grid>
                        <Grid item xs={12}>
                            <PanDetailsReview reviewData={reviewData} />
                            <PersonalDetailsReview reviewData={reviewData} />
                            <AddressDetailsReview reviewData={reviewData} />
                            <FATCADetailsReview reviewData={reviewData} />
                            <NomineeDetailsReview reviewData={reviewData} />
                            <BankDetailsReview reviewData={reviewData} />
                            <BrokerageDetailsReview reviewData={reviewData} />
                            <PaymentDetailsReview reviewData={reviewData} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" css={{ fontWeight: "bold", paddingBottom:"10px" }}>
                                {localeText?.reviewUploadedDocs}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper>
                                <Grid item xs={12}>
                                    <UploadedDocuments reviewData={reviewData} setUploadedDocProofID={setUploadedDocProofID} />
                                </Grid>
                            </Paper>
                        </Grid>
                        
                        <Grid item xs={8} md={4} lg={3} css={{ marginTop: "0px" }}>
                            <Button display="inline" variant={"outlined"} color="error" css={{width: "100%"}} onClick={handleDownloadForm}>
                                {localeText?.reviewDownloadForm}
                            </Button>
                        </Grid>
                        <Grid item xs={4} md={4} lg={2} css={{ marginTop: "0px" }}>
                            <Button display="inline"  variant='contained' color="primary" css={{width: "100%"}} onClick={handleFinalSubmit}>
                                {localeText?.reviewNextBtn}
                            </Button>
                        </Grid>
                    </Grid>
                </ElevatedGrid>
            </PageLayout>

            {loading && <FullScreenLoader />}

            <UploadedDocumentViewer proofID={uploadedDocProofID} setUploadedDocProofID={setUploadedDocProofID}/>

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default Review;
